// Channel creation and invitation is done through the ketchsupport id
export const SENDBIRD_CHANNEL_OWNER_ID = 'ketchsupport'
